import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import { FaEdit, FaPlay } from "react-icons/fa";
import { FaUserCheck, FaDisplay,  FaTrashCan, FaCircleXmark } from "react-icons/fa6";

import 'common/css/master.css';
import Header from 'common/js/header/header.js';

import { getPtmListSvc, cancelPtmSvc, deletePtmSvc } from './PtmTableSvc.js';

const PtmTable = props => {
  const [lstPtm, setLstPtm] = useState([])
  const [ptmId, setPtmId] = useState(0)
  useEffect(() => {
    // console.log("PTM table called");
    getPtmListSvc(cbPtmListResponse)
  }, [props.key])

  function cbPtmListResponse(data) {
    if (data.SvcStatus === 'Success') {
      setLstPtm(data.lstPtm)
    } else {
      toast.error(data.SvcStatus)
    }
  }
  function deletePtm(pPtmId) {
    setPtmId(ptmId);
    var r = window.confirm('Are you sure to delete the PTM')
    if (!r) {
      return false
    }
    deletePtmSvc(pPtmId, cbResponse)
  }
  function cancelPtm(pPtmId) {
    setPtmId(ptmId);
    var r = window.confirm('Are you sure to cancel the PTM')
    if (!r) {
      return false
    }
    cancelPtmSvc(pPtmId, cbResponse)
  }

  function cbResponse(data) {
    // console.log("cbResponse called in PtmTable , data",data);
    if (data.SvcStatus === 'Success') {
      // console.log("data.SvcStatus === 'Success'");
      toast.success(data.SvcMsg)
      props.refreshTable();
    } else {
      // console.log("condition not true data.SvcStatus === 'Success' ");
      toast.error(data.SvcMsg)
    }
  }
  return (
    <div>
      <div className='col-sm-11' style={{ margin: '1% auto', padding: 0 }}>
        <table className='tableLayout1'>
          <thead>
            <tr>
              <th style={{ display: 'none' }}> Ptm Id </th>
              <th style={{ width: 40 }} className='text-center'>
                Date
              </th>
              <th style={{ width: 60 }} className='text-center'>
                Objective
              </th>
              <th style={{ width: 50 }} className='text-center'>
                Timings
              </th>
              <th style={{ width: 25 }} className='text-center'>
                SMS
              </th>
              <th style={{ width: 25 }} className='text-center'>
                WhatsApp
              </th>
              <th style={{ width: 25 }} className='text-center'>
                Email
              </th>
              <th style={{ width: 25 }} className='text-center'>
                IVR
              </th>
              <th style={{ width: 25 }} className='text-center'>
                Parent Welcome
              </th>
              <th style={{ width: 25 }} className='text-center'>
                Student Accolade
              </th>
              <th style={{ width: 40 }} className='text-center'>
                Language
              </th>
              <th style={{ width: 80 }} className='text-center'>
                Action
              </th>
            </tr>
          </thead>
        </table>
        <div
          className='tableBodyWrapper'
          style={{
            height: '500px',
            overflowY: 'scroll',
            border: '1px solid #ccc'
          }}
        >
          <table id='ptmTable' className='tableLayout'>
            <colgroup>
              <col width='35' />
              <col width='60' />
              <col width='50' />
              <col width='25' />
              <col width='25' />
              <col width='25' />
              <col width='25' />
              <col width='25' />
              <col width='25' />
              <col width='40' />
              <col width='80' />
            </colgroup>
            <tbody>
              {lstPtm.map((obj, idx) => {
                return (
                  <tr
                    onClick={e => {
                      setPtmId(obj.ptmId)
                      props.setPtmData(obj.ptmId, obj.objective, obj.timings)
                    }}
                    className={obj.ptmId === ptmId ? 'selected' : ''}
                    key={idx}
                  >
                    <td className='no-display'>{obj.ptmId}</td>
                    <td className='text-center'>{obj.ptmDt}</td>
                    <td className='text-left'>{obj.objective}</td>
                    <td className='text-center'>{obj.timings}</td>
                    <td className='text-center'>{obj.flgSms ? 'Yes' : '-'}</td>
                    <td className='text-center'>
                      {obj.flgWhatsapp ? 'Yes' : '-'}
                    </td>
                    <td className='text-center'>
                      {obj.flgEmail ? 'Yes' : '-'}
                    </td>
                    <td className='text-center'>{obj.flgIvr ? 'Yes' : '-'}</td>
                    <td className='text-center'>{obj.parentsWelcome ? 'Yes' : '-'}</td>
                    <td className='text-center'>{obj.studentAccolade ? 'Yes' : '-'}</td>
                    <td className='text-center'>{obj.localeLanguage}</td>
                    <td className='text-center' >
                      <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", }}>
                        <FaEdit
                          title='Edit PTM'
                          onClick={e => props.openSlider(10, obj.ptmId)}
                          color="gray"
                          style={{ fontSize: "15px", cursor: "pointer" }}
                        />
                        <FaUserCheck
                          onClick={e => props.openSlider(20, obj.ptmId)}
                          title="Mark Students Attendance"
                          color="gray"
                          style={{ fontSize: "15px", cursor: "pointer" }}
                        />
                        <FaDisplay
                          title="PTM Display"
                          onClick={e => window.open("/ptmDisplayCtrl?ptmId=" + obj.ptmId, '_blank')}
                          color="gray"
                          style={{ fontSize: "15px", cursor: "pointer" }}
                        />
                        <FaPlay
                          title="Play"
                          onClick={e => window.open("/ptmSlideShowCtrl?ptmId=" + obj.ptmId, '_blank')}
                          color="green"
                          style={{ fontSize: "15px", cursor: "pointer" }}
                        />
                        <FaTrashCan
                          title="Delete"
                          onClick={e => deletePtm(obj.ptmId)}
                          color="red"
                          style={{ fontSize: "15px", cursor: "pointer" }}
                        />
                        <FaCircleXmark
                          title="Cancel"
                          onClick={e => cancelPtm(obj.ptmId)}
                          color="gray"
                          style={{ fontSize: "15px", cursor: "pointer" }}
                        />
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
export default PtmTable
